import { inject, Pipe, PipeTransform } from "@angular/core";
import { DatasetWebConverter } from 'dev/components/elad.forms2/services/dataset.web.converter';

@Pipe({name: 'cpTableName'})
export class TableNamePipe implements PipeTransform {
    
    private dsWebConverterSvc = inject(DatasetWebConverter);

	transform(path: string, displayField: boolean = false) : string {
     return this.dsWebConverterSvc.displayTableName(path, displayField);
	}
}
